/* eslint-disable */ 
import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import money from 'v-money'
Vue.use(money, {precision: 4})
// import VueRouter from 'vue-router'
// Vue.use(VueRouter)
// import Routes from './router'
// const router = new VueRouter({
//     routes : Routes,
//     mode: 'history'
// })

Vue.config.productionTip = false

new Vue({
    // router : router,
    render: h => h(App),
}).$mount('#app')
